import './App.scss';
import styled from 'styled-components';
import axios from 'axios';
import { AppSettingsStateProvider } from './context/AppSettingsStateContext';
import { AuthContextProvider } from './context/AuthContext';

// Use fetch adapter for HTTP/2 support
axios.defaults.adapter = 'fetch';
import { ConnectionProvider } from './context/ConnectionContext';
import AppRouter from './route/AppRouter';
import { DateProvider } from './context/DateContext';
import { EventProvider } from './context/EventContext';
import { AppContextProvider } from './context/AppContext';
import { EventTypeProvider } from './context/EventTypeContext';
import { RotationProvider } from './context/RotationContext';
import { VesselProvider } from './context/VesselContext';
// FontAwesome icons are now imported directly in components where needed
// This enables better tree-shaking and reduces initial bundle size
import { AolProvider } from './context/AolContext';
import { Toaster } from 'react-hot-toast';
import theme from './theme';
import { TankCleaningProvider } from './context/TankCleaningContext';
import { LoaderContextProvider } from './context/LoaderContext';
import { UserSettingsContextProvider } from './context/UserSettingsContext';
import { CargoTempLogProvider } from './context/CargoTempLogContext';
import { VerificationProvider } from './context/VerificationContext';
import { BerthProvider } from './context/BerthContext';
import { QueryParamsProvider } from 'odfjell-query-manager/QueryParamsContext';
import { PbiReportsContextProvider } from './context/PbiReportsContext';
import { StowageProvider } from './context/StowageContext';
import { BunkerProvider } from './context/BunkerContext';
import { StowageRuleProvider } from './context/StowageRuleContext';
import { ViolationsProvider } from './context/ViolationsContext';
import ResolutionSimulatorWrapper from './components/resolutionSimulatorWrapper/ResolutionSimulatorWrapper';
import { StowageSelectionProvider } from './context/StowageSelectionContext';
import { RetroactiveCargoModeProvider } from './context/RetroactiveCargoModeContext';
import { ErrorLoggingInitializer } from './components/common/ErrorLoggingInitializer';

const AppContainer = styled.div`
    color: ${theme.legacyColors.darkBlue};
    height: 100%;
    overflow: hidden;
    min-width: ${theme.constants.appMinWidth};
`;

const AppComponent = () => {
    return (
        <AppContextProvider>
            <ResolutionSimulatorWrapper>
                <div className="content">
                    <AppContainer>
                        <Toaster position="top-right" reverseOrder={false} />
                        <AppSettingsStateProvider>
                            <QueryParamsProvider>
                                <ConnectionProvider>
                                    <LoaderContextProvider>
                                        <AuthContextProvider>
                                            <ErrorLoggingInitializer />
                                            <UserSettingsContextProvider>
                                                <DateProvider>
                                                    <EventProvider>
                                                        <EventTypeProvider>
                                                            <RotationProvider>
                                                                <VesselProvider>
                                                                    <RetroactiveCargoModeProvider>
                                                                        <TankCleaningProvider>
                                                                            <CargoTempLogProvider>
                                                                                <VerificationProvider>
                                                                                    <AolProvider>
                                                                                        <BerthProvider>
                                                                                            <PbiReportsContextProvider>
                                                                                                <StowageProvider>
                                                                                                    <StowageSelectionProvider>
                                                                                                        <StowageRuleProvider>
                                                                                                            <ViolationsProvider>
                                                                                                                <BunkerProvider>
                                                                                                                    <AppRouter />
                                                                                                                </BunkerProvider>
                                                                                                            </ViolationsProvider>
                                                                                                        </StowageRuleProvider>
                                                                                                    </StowageSelectionProvider>
                                                                                                </StowageProvider>
                                                                                            </PbiReportsContextProvider>
                                                                                        </BerthProvider>
                                                                                    </AolProvider>
                                                                                </VerificationProvider>
                                                                            </CargoTempLogProvider>
                                                                        </TankCleaningProvider>
                                                                    </RetroactiveCargoModeProvider>
                                                                </VesselProvider>
                                                            </RotationProvider>
                                                        </EventTypeProvider>
                                                    </EventProvider>
                                                </DateProvider>
                                            </UserSettingsContextProvider>
                                        </AuthContextProvider>
                                    </LoaderContextProvider>
                                </ConnectionProvider>
                            </QueryParamsProvider>
                        </AppSettingsStateProvider>
                    </AppContainer>
                </div>
            </ResolutionSimulatorWrapper>
        </AppContextProvider>
    );
};

export default AppComponent;
